import { render, staticRenderFns } from "./FindAccountPassword.vue?vue&type=template&id=35967a5c&"
import script from "./FindAccountPassword.vue?vue&type=script&lang=js&"
export * from "./FindAccountPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports